import React from 'react';
import DocumentHeader from '../../../Documents/components/DocumentHeader';
import OriginalPreview from '../../Copy/components/OriginalPreview';
import NewPreview from '../../Copy/components/NewPreview';
import MoveReplaceConfirmModal from './MoveReplaceConfirmModal';
import Loader from '../../../../common/Loader';

/**
 * MoveReplacePreview Component
 * Reuses the same preview structure as CopyReplacePreview
 * Displays the preview of original vs new document state after move
 * For same-document moves: shows single document preview
 * For cross-document moves: shows target document preview
 */
const MoveReplacePreview = ({
  moveDocument,
  moveNode,
  moveTargetDocument,
  movePosition,
  previewMode,
  originalData,
  newData,
  onPreviewModeChange,
  onConfirm,
  comment,
  onCommentChange,
  isLoading,
  isModalOpen,
  onModalClose,
  moveCreateCopy
}) => {
  // For move, targetDocument is either the same as moveDocument (same-doc move) or moveTargetDocument (cross-doc)
  const targetDocument = moveTargetDocument || moveDocument;

  const handleModalSave = () => {
    if (onConfirm) {
      onConfirm();
    }
    if (onModalClose) {
      onModalClose();
    }
  };

  return (
    <div style={{ padding: '20px', position: 'relative' }}>
      {/* Document Header - Show target document header above preview */}
      {targetDocument && (
        <DocumentHeader
          type={targetDocument.type}
          partNumber={targetDocument.partNumber}
          revision={targetDocument.revision}
          revisionId={targetDocument.revisionId}
          partId={targetDocument.partId}
          // description={targetDocument.description}
          description={false}
          status={targetDocument.status}
          currentRevision={null}
          showCheckbox={false}
          showVersionInfo={false}
          isCheckboxEnabled={false}
        />
      )}

      {/* Preview Content */}
      {previewMode === 'original' ? (
        <OriginalPreview
          data={originalData}
          targetDocument={targetDocument}
        />
      ) : (
        <NewPreview
          originalData={originalData}
          sourceData={moveDocument}
          targetDocument={targetDocument}
          newData={newData}
        />
      )}

      {/* Confirmation Modal */}
      {isModalOpen && (
        <MoveReplaceConfirmModal
          moveDocument={moveDocument}
          moveNode={moveNode}
          moveTargetDocument={moveTargetDocument}
          movePosition={movePosition}
          comment={comment}
          onCommentChange={onCommentChange}
          onClose={onModalClose}
          onSave={handleModalSave}
          isLoading={isLoading}
          moveCreateCopy={moveCreateCopy}
          originalData={originalData}
        />
      )}

      {/* Submitting overlay loader */}
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(255,255,255,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <Loader text="Moving" />
        </div>
      )}
    </div>
  );
};

export default MoveReplacePreview;

